import React from 'react';
import PropTypes from 'prop-types';
import { Input, Menu } from '@one-thd/sui-atomic-components';
import NumericRangeMenu from './NumericRangeMenu';

const NumericRangeInput = ({
  id,
  placeholder,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  open,
  anchorRef,
  onScrollDropDown,
  onClickOfDropDown,
  items,
  minValue,
  isMaxValue
}) => (
  <section className="sui-flex-1 sui-relative">
    <Input
      id={id}
      data-testid={name}
      placeholder={placeholder}
      name={name}
      inputProps={{ 'aria-label': `drawer-${name}-input` }}
      type="text"
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      fullWidth
      ref={anchorRef}
      aria-controls={open ? `${name}-menu` : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
    />
    <Menu
      id={`${name}-menu`}
      data-testid={`drawer-${name}-menu`}
      open={open}
      anchorEl={anchorRef.current}
      onScroll={(_event) => onScrollDropDown(name)}
      MenuListProps={{ 'aria-labelledby': `drawer-${name}-menu` }}
      className="sui-z-tooltip"
    >
      <NumericRangeMenu
        items={items}
        onClickOfDropDown={onClickOfDropDown}
        isMaxValue={isMaxValue}
        minValue={minValue}
      />
    </Menu>
  </section>
);

NumericRangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  anchorRef: PropTypes.shape({
    current: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  }).isRequired,
  onScrollDropDown: PropTypes.func.isRequired,
  onClickOfDropDown: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired
  })).isRequired,
  minValue: PropTypes.string.isRequired,
  isMaxValue: PropTypes.bool
};

NumericRangeInput.defaultProps = {
  isMaxValue: false
};

export default NumericRangeInput;